/**
 * useMoiConnecte.ts — S232 (R-S232-05, écart 5 ; P-S232-06, partie C) : la barre du haut de la V3 affiche l'utilisateur connecté, lu dans
 * GET /api/v1/auth/me (nom, avatar, courriel ; api_rest.py:2353-2361) avec le jeton du navigateur, comme BandeauDemo et les hooks V3
 * (aucun import de l'interface précédente, garde-fou V2IMPORTS.GUARD.1). Avant : photo et nom de Carl écrits en dur pour tous les comptes
 * (ControlTowerPanel.tsx). Les deux comptes de Carl gardent leur affichage d'avant (sa photo, « Carl Fugère »), leurs fiches n'ayant ni
 * avatar ni nom complet ; tout autre compte montre son nom et son avatar, ou ses initiales. affichageUtilisateur est pure
 * (tests/test_s232_barre_utilisateur_js.py).
 */

import { useEffect, useState } from "react";

export type MoiConnecte = { nom?: string | null; avatar?: string | null; email?: string | null };
export type AffichageUtilisateur = { nom: string; photo: string | null; initiales: string };

export const COURRIELS_CARL = ["carl@ghostx.ai", "cfugere@usinebleue.ai"];
export const PHOTO_CARL = "/agents/carl-fugere.jpg";
export const NOM_CARL = "Carl Fugère";

function initialesDe(nom: string): string {
  const mots = nom.split(/[\s.@_-]+/).filter(Boolean);
  return ((mots[0]?.[0] || "") + (mots[1]?.[0] || "")).toUpperCase() || "?";
}

export function affichageUtilisateur(me?: MoiConnecte | null): AffichageUtilisateur {
  if (!me) return { nom: "", photo: null, initiales: "" };
  const courriel = String(me.email || "").trim().toLowerCase();
  if (COURRIELS_CARL.includes(courriel) && !me.avatar) return { nom: NOM_CARL, photo: PHOTO_CARL, initiales: "CF" };
  const nom = String(me.nom || "").trim() || courriel;
  const photo = typeof me.avatar === "string" && /^(\/|https?:\/\/)/.test(me.avatar) ? me.avatar : null;
  return { nom, photo, initiales: initialesDe(nom) };
}

const _KEY = (import.meta as unknown as { env?: Record<string, string | undefined> }).env?.VITE_API_KEY || "missing-key";

export function useMoiConnecte(): AffichageUtilisateur {
  const [me, setMe] = useState<MoiConnecte | null>(null);
  useEffect(() => {
    let vivant = true;
    let jwt: string | null = null;
    try { jwt = localStorage.getItem("ghostx-jwt"); } catch { jwt = null; }
    if (!jwt) return;
    fetch("/api/v1/auth/me", { headers: { "X-API-Key": _KEY, Authorization: `Bearer ${jwt}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (vivant && d) setMe(d as MoiConnecte); })
      .catch(() => { /* sans réponse : barre neutre */ });
    return () => { vivant = false; };
  }, []);
  return affichageUtilisateur(me);
}
